/**
 * Comparison Table Section
 * Handles mobile horizontal scroll progress bar
 */
(function () {
  function initSection(sectionEl) {
    if (!sectionEl) return;

    var scrollContainer = sectionEl.querySelector('[data-scroll-container]');
    var progressFill = sectionEl.querySelector('[data-scroll-fill]');

    if (!scrollContainer || !progressFill) return;

    var rafScroll = null;
    function updateProgress() {
      var scrollLeft = scrollContainer.scrollLeft;
      var scrollWidth = scrollContainer.scrollWidth;
      var clientWidth = scrollContainer.clientWidth;
      var maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 0) {
        progressFill.style.width = '100%';
        progressFill.style.marginLeft = '0%';
        return;
      }

      var progress = (scrollLeft / maxScroll) * 100;
      var visibleRatio = clientWidth / scrollWidth;
      var fillWidth = visibleRatio * 100;
      var offset = (progress / 100) * (100 - fillWidth);
      progressFill.style.width = fillWidth + '%';
      progressFill.style.marginLeft = offset + '%';
    }

    function onScroll() {
      if (rafScroll != null) return;
      rafScroll = window.requestAnimationFrame(function () {
        rafScroll = null;
        updateProgress();
      });
    }

    function onResize() {
      updateProgress();
    }

    scrollContainer.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    var resizeObserver = null;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function () {
        updateProgress();
      });
      resizeObserver.observe(scrollContainer);
    }

    // Store cleanup reference on the element
    sectionEl.__comparisonCleanup = function () {
      scrollContainer.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if (rafScroll != null) {
        window.cancelAnimationFrame(rafScroll);
        rafScroll = null;
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };

    updateProgress();
    window.requestAnimationFrame(updateProgress);
  }

  // Initialise all instances on the page
  document.querySelectorAll('.oddit-section-comparison').forEach(function (el) {
    initSection(el);
  });

  // Theme editor support
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.oddit-section-comparison');
      if (section) {
        initSection(section);
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target.querySelector('.oddit-section-comparison');
      if (section && section.__comparisonCleanup) {
        section.__comparisonCleanup();
      }
    });
  }
})();
